"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _fetchWithAuth = _interopRequireDefault(require("../services/fetchWithAuth"));

var CARRIER_SERVICE_BASE_URL = 'https://carriers.logistics.cimpress.io';

var useCarrier = function useCarrier(_ref) {
  var carrierServiceKey = _ref.carrierServiceKey,
      accessToken = _ref.accessToken;
  return (0, _reactQuery.useQuery)(['getCarrierData', carrierServiceKey, accessToken], function () {
    return (0, _fetchWithAuth["default"])({
      accessToken: accessToken,
      endpointUrl: CARRIER_SERVICE_BASE_URL,
      route: "api/v1/carrierServices/".concat(carrierServiceKey)
    });
  }, {
    retry: false,
    enabled: carrierServiceKey
  });
};

var _default = useCarrier;
exports["default"] = _default;